import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import BottomNav from '@/components/BottomNav';
import TopNav from '@/components/TopNav';
import CrisisTopBanner from '@/components/CrisisTopBanner';
import FeedbackWidget from '@/components/FeedbackWidget';
import OnboardingTour from '@/components/OnboardingTour';
import SurveyModal from '@/components/SurveyModal';
import TrialBanner from '@/components/TrialBanner';
import HelpButton from '@/components/HelpButton';import WhatsNewModal from '@/components/WhatsNewModal';
import AgreementGate from '@/components/AgreementGate';
import GlobalSearch from '@/components/GlobalSearch';
import { initAnalytics, trackPageview } from '@/lib/analytics';
import { entranceAudio } from '@/lib/entranceAudio';

export default function AppShell() {
  const { user, loading } = useAuth();
  const location = useLocation();

  useEffect(() => { initAnalytics(); entranceAudio.stop(); }, []);
  useEffect(() => { trackPageview(location.pathname); }, [location.pathname]);

  if (loading) return <div className="min-h-screen flex items-center justify-center text-navy/60">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  // Paywall: an active membership (PayPal) is required. Admins/owners bypass.
  const hasSubscription = user.is_admin || user.bootstrap_owner
    || user.is_premium
    || ['active', 'trialing'].includes(user.subscription_status);
  if (!hasSubscription) return <Navigate to="/subscription/checkout" replace />;
  if (!user.onboarded) return <Navigate to="/onboarding" replace />;
  return (
    <div className="min-h-screen bg-ivory overflow-x-clip">
      <CrisisTopBanner />
      <TopNav />
      <div className="max-w-md lg:max-w-[1400px] mx-auto pb-28 lg:pb-16 lg:px-6 overflow-x-clip">
        <TrialBanner />
        <Outlet />
        <footer data-testid="app-footer" className="mt-10 px-4 pt-6 pb-2 border-t border-navy/10 text-center">
          <p className="text-[11px] sm:text-xs text-navy/60 leading-relaxed">
            Brotherhood+ is not a substitute for professional care ·{' '}
            <span className="whitespace-nowrap">
              In crisis, call or text{' '}
              <a href="tel:988" data-testid="footer-crisis-988" className="inline-block px-1.5 py-1 font-semibold text-navy underline underline-offset-2 hover:text-gold transition-smooth">988</a>
            </span>
          </p>
          <p className="mt-1 text-[10px] sm:text-[11px] text-navy/40">
            © 2026 Renewing Minds Counseling and Consulting Services. All rights reserved.
          </p>
          <a href="/therapist-apply" data-testid="footer-apply-therapist" className="mt-2 inline-block text-[11px] text-navy/50 hover:text-gold underline underline-offset-2 transition-smooth">
            Are you a therapist? Apply to be listed
          </a>
        </footer>
      </div>
      <BottomNav />
      <FeedbackWidget />
      <AgreementGate />
      <OnboardingTour />
      <SurveyModal />
      <WhatsNewModal />
      <HelpButton />
      <GlobalSearch />
    </div>
  );
}
